import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TIMESLOT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('slot', 'Entity.TimeSlot.Slot')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const TIMESLOT_CONFIG = {
  entityName: 'TimeSlot',
  localizationKey: 'General::Entity.TimeSlot',
  fields: TIMESLOT_FIELDS,
  permission: 'Harvest.TimeSlots',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Harvest + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
